export const ASSETS = {
  hero: "https://static.prod-images.emergentagent.com/jobs/0c2d65a7-a6c1-4ed9-8c6c-8c9aeadb902b/images/5dd92fbceed77c2821d46fbb18ad47d62a5493dbea7b8117fd98c897b8198968.png",
  sprig: "https://customer-assets-39nsmqrw.emergentagent.net/job_quantum-healing-hub-1/artifacts/846xkcd5_lavender-sprig.png",
  logo: "https://customer-assets.emergentagent.com/job_0c2d65a7-a6c1-4ed9-8c6c-8c9aeadb902b/artifacts/emhwb1a3_logo1.jpeg",
  forestPortal: "https://customer-assets.emergentagent.com/job_0c2d65a7-a6c1-4ed9-8c6c-8c9aeadb902b/artifacts/ufw2nch5_vortex1.jpg",
  flyer: "https://customer-assets.emergentagent.com/job_0c2d65a7-a6c1-4ed9-8c6c-8c9aeadb902b/artifacts/fh37rvnj_poster1.jpg",
  womanSea: "https://images.unsplash.com/photo-1461468611824-46457c0e11fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  womanField: "https://images.unsplash.com/photo-1596542519315-6db93bdf7548?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cardLavender: "https://images.unsplash.com/photo-1600759487717-62bbb608106e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  cardStillness: "https://images.unsplash.com/photo-1763713383838-5cd702c13160?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  cardShore: "https://images.pexels.com/photos/261536/pexels-photo-261536.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=800",
  ctaDawn: "https://images.pexels.com/photos/16580590/pexels-photo-16580590.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  canopy: "https://images.pexels.com/photos/789397/pexels-photo-789397.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
};

// Curated free-image library (lavender, coastal & calm-nature) — reusable across pages.
export const IMAGE_LIBRARY = {
  lavender: {
    lavenderCloseup: "https://images.unsplash.com/photo-1625215393266-d09797f4a441?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    lavenderField: "https://images.unsplash.com/photo-1600759487717-62bbb608106e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    lavenderHeather: "https://images.unsplash.com/photo-1477511801984-4ad318ed9846?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  coastal: {
    coastCliffs: "https://images.unsplash.com/photo-1737547670396-ae9fd016aae5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    coastMistyShore: "https://images.unsplash.com/photo-1769969459410-c07de924ab87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    coastDawnRocks: "https://images.pexels.com/photos/261536/pexels-photo-261536.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    coastSunriseHills: "https://images.pexels.com/photos/16580590/pexels-photo-16580590.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
    coastTwilight: "https://images.unsplash.com/photo-1768060146636-f7202f967015?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  nature: {
    womanReeds: "https://images.unsplash.com/photo-1759873911661-d4cba84d2eff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    womanGreenery: "https://images.pexels.com/photos/1053506/pexels-photo-1053506.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1000",
    forestCanopy: "https://images.pexels.com/photos/789397/pexels-photo-789397.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
};

export const LIB = {
  ...IMAGE_LIBRARY.lavender,
  ...IMAGE_LIBRARY.coastal,
  ...IMAGE_LIBRARY.nature,
};

export const PRACTITIONER = {
  name: "Isabelle Legér",
  business: "Inner Light Healing",
  location: "Near Ivybridge, South Devon",
  email: "isabelle@materiaaromatica.com",
  emailDisplay: "isabelle@innerlight-healing.co.uk",
  phone: "+44 (0) 7700 900123",
};

export const SESSION_TYPES = [
  "Free Volunteer Session (women only)",
  "Full QHHT Session",
  "Discovery Call (free, 20 min)",
];

export const TIME_SLOTS = [
  "Morning (arrive 9:00am)",
  "Afternoon (arrive 1:00pm)",
];

export const QHHT_PRINCIPLES = [
  {
    title: "A gentle, guided journey",
    body: "Through deep relaxation you are guided into a calm, dream-like state — much like the moments before sleep. You remain aware and in control throughout.",
  },
  {
    title: "Meeting your Higher Self",
    body: "QHHT invites a connection with the wise, knowing part of you that Dolores Cannon called the Subconscious or Higher Self — a source of insight and inner guidance.",
  },
  {
    title: "Insight & inner healing",
    body: "Many women describe a profound sense of clarity, peace and emotional release as they explore their questions in a safe, supportive space.",
  },
];

export const EXPECT_STEPS = [
  {
    n: "01",
    title: "A warm welcome & conversation",
    body: "We begin with an unhurried, heart-centred chat about your life, what has brought you here, and the questions you would love to explore. There is no rush — this is your time.",
  },
  {
    n: "02",
    title: "Gentle relaxation",
    body: "Resting comfortably, you are softly guided into a deeply relaxed state. Nothing is forced. You stay aware and safe, free to pause at any moment.",
  },
  {
    n: "03",
    title: "Exploring & inner guidance",
    body: "We gently explore the experiences and insights that arise, then invite your Higher Self to respond to your prepared questions with warmth and wisdom.",
  },
  {
    n: "04",
    title: "Returning & reflection",
    body: "You return calmly to full awareness and we share a quiet cup of tea, reflecting together. You'll receive a recording of your session to revisit at home.",
  },
];

export const SESSION_FACTS = [
  { label: "A relaxed, one-to-one session", detail: "In a safe and supportive environment" },
  { label: "Explore your questions", detail: "Insights and inner guidance" },
  { label: "A full QHHT session", detail: "Lasting around 4 hours" },
  { label: "Deep relaxation", detail: "Using hypnosis to access your Higher Self" },
];

export const FAQS = [
  {
    q: "What is QHHT?",
    a: "The Quantum Healing Hypnosis Technique (QHHT) was developed by the late Dolores Cannon over several decades. It uses gentle, guided relaxation to help you connect with the deeper, wiser part of yourself for insight and a sense of inner peace.",
  },
  {
    q: "Will I be asleep or unconscious?",
    a: "No. You remain aware and in control the entire time. The state feels much like daydreaming or the drowsy moments just before sleep — deeply relaxing, never frightening. You can speak, pause, or stop whenever you wish.",
  },
  {
    q: "How long is a session?",
    a: "A full QHHT session typically lasts around four hours, including a relaxed conversation beforehand and time to reflect afterwards. Please allow the whole day so you never feel rushed.",
  },
  {
    q: "Why are the volunteer sessions for women only?",
    a: "Isabelle is currently completing her Level 2 QHHT training and is offering complimentary sessions to female volunteers in a comfortable, women-only space where everyone can feel safe and at ease.",
  },
  {
    q: "How should I prepare?",
    a: "Bring a written list of the questions you'd most like to explore, get a good night's rest, eat lightly and avoid excess caffeine or alcohol beforehand. Wear comfortable clothing and clear your day so you can relax fully.",
  },
  {
    q: "Is QHHT a substitute for medical care?",
    a: "No. QHHT is a complementary practice for relaxation, reflection and wellbeing. It is not a medical or psychological treatment and does not diagnose, treat or cure any condition. Please continue any care advised by your doctor and consult a medical professional for health concerns.",
  },
  {
    q: "Is my session confidential?",
    a: "Absolutely. Everything shared before, during and after your session is treated with the utmost confidentiality and care. You will receive a private recording of your session for your own use.",
  },
];

export const SAFETY_POINTS = [
  "QHHT is a complementary wellbeing practice — it is not medical, psychological or psychiatric treatment.",
  "It does not diagnose, treat, cure or prevent any illness or condition.",
  "Please continue any treatment or medication advised by your doctor and seek medical advice for health concerns.",
  "Sessions are unsuitable for anyone experiencing acute mental-health crises; appropriate professional support should be sought instead.",
  "You remain fully in control throughout and may pause or end your session at any time.",
  "You must be 18 or over to book a session.",
];
